namespace ui
{
	declare class woothee
	{
		public static parse( userAgent: string ): {[key: string]: string};
	}

	let ua_INSTANCE: UserAgent;

	export class UserAgent
	{

		public readonly	OS:				string;
		public readonly	Browser:	string;
		public readonly	Version:	string;
		public readonly	Platform:	string;
		public readonly	Locale:		string;

		private constructor()
		{
			this.OS				= 'undefined';
			this.Browser	= 'undefined';
			this.Version	= 'undefined';
			this.Platform	= 'undefined';
			this.Locale		= navigator.language;

			try
			{
				const uaw: {[key: string]: string} = woothee.parse( navigator.userAgent );

				this.OS				= uaw.os;
				this.Browser	= uaw.name;
				this.Version	= uaw.version;
				this.Platform	= uaw.category;
			}
			catch ( e ) {}
		}

		public static Instance(): UserAgent
		{
			if ( !ua_INSTANCE )
			{
				ua_INSTANCE	= new UserAgent();
			}

			return ua_INSTANCE;
		}

	}
}
